import { PaymentInfo } from '@/api/payments'
import { Company } from '@/types/company'
import { UserProfile } from '@/types/user-profile'
import { ReactElement, useEffect, useRef, useState } from 'react'
import { makeSteps } from '../utils/stepConfig'

interface UseStableStepsProps {
  company: Company | undefined
  companyId: string
  user: UserProfile
  paymentMethods: PaymentInfo[]
  isCompanyLoading: boolean
  isPaymentMethodsLoading: boolean
}

export const useStableSteps = ({
  company,
  companyId,
  user,
  paymentMethods,
  isCompanyLoading,
  isPaymentMethodsLoading,
}: UseStableStepsProps): ReactElement[] => {
  const [steps, setSteps] = useState<ReactElement[]>([])
  const hasCalculatedRef = useRef(false)

  useEffect(() => {
    if (
      company &&
      !isCompanyLoading &&
      !isPaymentMethodsLoading &&
      !hasCalculatedRef.current
    ) {
      const calculatedSteps = makeSteps({
        company,
        companyId,
        user,
        paymentMethods,
        companyAddressId: company.address?.addressId,
      })

      setSteps(calculatedSteps)
      hasCalculatedRef.current = true
    }
  }, [
    company,
    companyId,
    user,
    paymentMethods,
    isCompanyLoading,
    isPaymentMethodsLoading,
  ])

  return steps
}
